function hideProductModal() {
    const productModal = document.querySelectorAll("product-modal[open]");
    productModal.forEach(modal => modal.hide());
}

document.addEventListener("shopify:block:select", function(event) {
    hideProductModal();
    if (!event.target.classList.contains("slideshow__slide")) return;

    const parentSlideshowComponent = event.target.closest("slideshow-component");
    parentSlideshowComponent.pause();

    setTimeout(function() {
        parentSlideshowComponent.slider.scrollTo({
            left: event.target.offsetLeft
        });
    }, 200);
});

document.addEventListener("shopify:block:deselect", function(event) {
    if (!event.target.classList.contains("slideshow__slide")) return;

    const parentSlideshowComponent = event.target.closest("slideshow-component");
    if (parentSlideshowComponent.autoplayButtonIsSetToPlay) {
        parentSlideshowComponent.play();
    }
});

document.addEventListener("shopify:section:load", () => {
    hideProductModal();
    const zoomOnHoverScript = document.querySelector("[id^=EnableZoomOnHover]");
    if (zoomOnHoverScript) {
        const newScriptTag = document.createElement("script");
        newScriptTag.src = zoomOnHoverScript.src;
        zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
    }
});

document.addEventListener("shopify:section:reorder", hideProductModal);
document.addEventListener("shopify:section:select", hideProductModal);
document.addEventListener("shopify:section:deselect", hideProductModal);
document.addEventListener("shopify:inspector:activate", hideProductModal);
document.addEventListener("shopify:inspector:deactivate", hideProductModal);

document.addEventListener("DOMContentLoaded", function() {
    console.log("Modal script is running");
    const modal = document.getElementById("contactFormModal");

    // Debugging output to check if the modal is found
    console.log("Modal element:", modal);

    if (modal) {
        // Display the modal when the page loads
        modal.style.display = "block";

        // Close modal when clicking outside the modal content
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        };
    } else {
        console.error("Modal not found!"); // Log an error if modal is not found
    }
});

function closeModal() {
    const modal = document.getElementById("contactFormModal");
    if (modal) {
        modal.style.display = "none";
    }
}

